import React, { useState } from 'react';
import { KoCheckBox,  KoForm, KoButton, KoDataTableEdit, KoNano } from 'packages';
import KoIcon from '@kwapio/icons';
import styles from './curd.module.scss';

function DiscountCrud({ form, settings }) {

  const [dataSource, setDataSource] = useState(settings?.discount?.length > 0 ? settings?.discount : [{
    key: KoNano('DIS'),
    discountName: null,
    discountRate: null,
    isDefault: false
  }]);

  const handleDelete = (key) => {
    let newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    if(newData.length === 0){
      newData =[{
        key: KoNano('DIS'),
        discountName: null,
        discountRate: null,
        isDefault: false
      }];
    }
    handleSave(newData);
  };

  const columns = [
    {
      dataIndex: 'discountName',
      title: 'Discount Name',
      width: 200,
      editable: true,
      widget: 'text',
      placeholder: 'Enter discount name'
    },
    {
      dataIndex: 'discountRate',
      title: 'Discount Rate (%)',
      editable: true,
      widget:'number',
      placeholder: 'Enter discount rate',
      width: 200
    },
    {
      dataIndex: 'isDefault',
      title: 'Set as Default',
      key: "isDefault",
      width: 200,
      render: (value, record, rowIndex) => (
        <KoCheckBox
          onChange={handleCheckboxChangeFactory(rowIndex, "isDefault")}
          checked={value}
          label={'set as default'}
        />
      )
    },
    {
      title: ` `,
      dataIndex: 'operation',
      width: 40,
      fixed:'right',
      render: (_, record, i) =>
        dataSource.length >= 1 ? (
          <div className={'editTableCol'}>
            <KoButton icon={<KoIcon width={12} height={12} name={'DeleteOutlined'} />} className={styles.actionBtn} onClick={() => handleDelete(record?.key)} label="" />
            {dataSource?.length === (i+1) && <KoButton icon={<KoIcon color={`var(--palette-gray-7)`} width={17} height={17} name={'PlusOutlined'} />} className={styles.actionBtn} onClick={() => handleAdd(record?.key)} label={``} />}
          </div>
        ) : null
    }
  ];

  const handleAdd = () => {
    const newData = {
      key: KoNano('DIS'),
      discountName: ``,
      discountRate: '',
      isDefault: false
    };
    setDataSource([...dataSource, newData]);
  };

  const handleCheckboxChangeFactory = (rowIndex, columnKey) => event => {
    const newCheckboxState = [...dataSource];
    newCheckboxState[rowIndex][columnKey] = event.target.checked;
    setDataSource(newCheckboxState);
    handleSave(newCheckboxState);
  };

  const handleSave = (newData) => {
    let data = form.getFieldsValue();
    data['discount'] = newData;
    form.setFieldsValue({...data});
    setDataSource(newData);
  };

  return (
    <div className={styles.wrapper}>
      <KoForm.Item name={'discount'}>
        <KoDataTableEdit
          dataSource={dataSource}
          form={form}
          onSave={handleSave}
          defaultColumns={columns} />
      </KoForm.Item>
    </div>
  );
};

export default DiscountCrud;